import React, { memo } from "react"
import PropTypes from "prop-types"

const PageNavigation = ({ children, navClasses, marginTop = 0 }) => {
  return (
    <aside
      className={
        navClasses ? `page-navigation ${navClasses}` : "page-navigation"
      }

    >
      {children}
    </aside>
  )
}

PageNavigation.propTypes = {
  children: PropTypes.node,
  navClasses: PropTypes.string,
  marginTop: PropTypes.number,
}

export default memo(PageNavigation)
